jQuery(document).ready(function ($) {

	// Smooth scrolling usando jQuery easing
	$('a.js-scroll-trigger[href*="#"]:not([href="#"])').on('click' ,function() {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: (target.offset().top - 100)
				}, 1000, "easeInOutExpo");
				return false;
			}
		}
	});

	/** Fixar form (apenas no desktop e quando a altura do form for menor que a altura máxima da área visível do navegador)*/
//	var sticky = new Sticky('[data-sticky]'); //deixando comentado pq esta LP é bem curtinha.


	/** Ação ao finalizar envio do formulário */
	var origConversionSuccess = conversionSuccess;
	conversionSuccess = function(resp) {
		origConversionSuccess(resp);
                if ($('#termo-aceite').is(":checked")) {
                    try { _gaq.push(['_trackPageview', '/lp-mit-salesforce-relatorio-shopping/conversao']); } catch(err) { }
                    //alert("Obrigado.");
                    location.href = 'https://mittechreview.com.br/wp-content/uploads/2020/11/mit_trbr_salesforce_relatorio_futuro_varejo.pdf';
                } else {
                    alert('O termo de aceite é obrigatório.');
                }
	};
});

$(document).on("input", "#num_funcionarios", function (e) {
  this.value = this.value.replace(/[^0-9]/g, '');
});

function mask(o, f) {
	setTimeout(function () {
		var v = f(o.value);
		if (v != o.value) {
			o.value = v;
		}
	}, 1);
}

function mphone(v) {
	var r = v.replace(/\D/g,"");
	r = r.replace(/^0/,"");
	if (r.length > 10) {
		r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/,"($1) $2-$3");
	}
	else if (r.length > 5) {
		r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/,"($1) $2-$3");
	}
	else if (r.length > 2) {
		r = r.replace(/^(\d\d)(\d{0,5})/,"($1) $2");
	}
	else if (r.length > 0) {
		r = r.replace(/^(\d*)/, "($1");
	}
	else {
		r = r.replace(/^(\d*)/, "$1");
	}
	return r;
}
